import api from '@/services/api'

import Auth from '../auth/index'
import { apiErrorHandler } from '../utils/apiErrors'

const ENGAGEMENT_ENDPOINT = 'engagements/'

export default class EngagementAPI {
  /**
   * Instantiate a new `EngagementAPI`
   * @param {class} cls - The class to use to create objects.
   */
  constructor(cls) {
    this.cls = cls
  }

  /**
   * Factory method to create a new instance of `EngagementAPI`.
   * @param {class} cls - The class to use to create objects.
   **/
  static create(cls) {
    return new EngagementAPI(cls)
  }

  /* Get the API Client. */
  get client() {
    return api.getApiClient()
  }

  /**
   * Retrieve one engagement from the API.
   *
   * @param {String} engagementId  Unique ID of the engagement to retrieve.
   */
  get(engagementId) {
    const url = `${ENGAGEMENT_ENDPOINT}${engagementId}/`
    return this.client
      .get(url)
      .then(response => this.cls.fromAPI(response.data))
      .catch(apiErrorHandler({ apiName: 'Get Engagement API error' }))
  }

  /**
   * Get List of Engagements via the API
   *
   * @returns {Promise} - Promise wrapping the API response data
   */
  async list({ filters = {} } = {}) {
    const authHeader = Auth.getAuthorizationHeader()
    const options = {
      headers: {
        ...authHeader,
      },
      params: {},
    }

    if (filters.page) {
      options.params.page = filters.page
    }

    return this.client
      .get(ENGAGEMENT_ENDPOINT, options)
      .then(response => {
        return {
          ...response.data,
          results: response.data.results.map(this.cls.fromAPI),
        }
      })
      .catch(apiErrorHandler({ apiName: 'List Engagements API error' }))
  }

  /**
   * Async retrieve a single Engagement from the API
   * @param {string} engagementId - ID of the Engagement to retrieve.
   * @returns {Promise} - Promise wrapping the retrieved `Engagement` instance.
   */
  async retrieve(engagementId) {
    const url = `${ENGAGEMENT_ENDPOINT}${engagementId}/`
    return this.client.get(url).then(response => this.cls.fromAPI(response.data))
  }
}
